<template>
  <div>
    <!-- Start Footer Area  -->
    <footer
      v-if="data.showFooter"
      class="rn-footer footer-style-default variation-two"
    >
      <!-- <div v-if="data.showCta" class="rn-callto-action clltoaction-style-default style-7">
                <div class="container">
                    <div class="row row--0 align-items-center content-wrapper">
                        <div class="col-lg-8 col-md-8">
                            <div class="inner" data-aos="fade-up">
                                <div class="content text-left">
                                    <Logo/>
                                    <p class="subtitle">
                                        If you want to create a corporate template you can purchase now our doob
                                        template.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4">
                            <div class="call-to-btn text-start mt_sm--20 text-lg-end" data-aos="fade-up">
                                <Button
                                    title="Purchase Doob"
                                    icon="arrow-right"
                                    url="#"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
      <div class="footer-top" v-if="data.footerStyle === 2">
        <div class="container">
          <div class="row">
            <div class="w-600 col-lg-3 col-md-4">
              <h4>{{ $t("footer.contact") }}</h4>
            </div>
            <div class="col-lg-2 col-md-3">
              <h4 class="w-400">400-009-8870</h4>
            </div>
            <div class="col-md-4">
              <a class="phone-number" href="mailto:marketing@vyung.com"
                >marketing@vyung.com</a
              >
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8 col-md-8 col-sm-8 col-12 row">
              <div class="col-lg-2 col-md-2 w-600 col-12">
                <h5 class="title">{{ $t("footer.fllow") }}</h5>
              </div>
              <div class="col-5 col-lg-3 col-md-3 mb-4">
                <div class="text-center qr-code">
                  <img
                    :src="require('@/assets/images/home/qr_gzh.png')"
                    alt=""
                  />
                  <span>{{ $t("footer.wechat_account") }}</span>
                </div>
              </div>
              <div class="col-5 col-lg-4 col-md-4">
                <div class="text-center qr-code w-100">
                  <img
                    :src="require('@/assets/images/home/qr_sph.png')"
                    alt=""
                  />
                  <span>{{ $t("footer.wechat_channel") }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-12 row">
              <div class="col-4 col-lg-3 col-md-3 w-600 col-12">
                <h5 class="title">{{ $t("footer.links") }}</h5>
              </div>
              <div class="col-lg-9 col-md-6 col-sm-6 col-12">
                <div class="rn-footer-widget">
                  <ul class="footer-link link-hover mt_dec--10">
                    <li>
                      <a target="_blank" href="https://www.hand-us.com/">{{
                        $t("footer.hand_us")
                      }}</a>
                    </li>
                    <li>
                      <a target="_blank" href="https://www.hand-europe.com/">{{
                        $t("footer.hand_eu")
                      }}</a>
                    </li>
                    <li>
                      <a target="_blank" href="https://www.hand-japan.co.jp/">{{
                        $t("footer.hand_jp")
                      }}</a>
                    </li>
                    <li>
                      <a target="_blank" href="https://www.hand-global.com/">{{
                        $t("footer.hand_sg")
                      }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-top" v-else-if="data.footerStyle === 1">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <div class="row">
                <div class="col-lg-3 col-md-3 w-600 col-12">
                  <h4>{{ $t("footer.contact") }}</h4>
                </div>
                <div class="col-lg-9 col-md-9 col-12">
                  <h4 class="w-400">400-009-8870</h4>
                  <a class="phone-number" href="mailto:marketing@vyung.com"
                    >marketing@vyung.com</a
                  >
                </div>
                <!-- <div class="col-4 col-lg-3 col-md-3">
                                    <a href="javascript:;"  data-bs-toggle="modal" data-bs-target="#exampleModal" >在线反馈</a>
                                    <FeedBack/>
                                </div> -->
              </div>
              <div class="row">
                <div class="col-4 col-lg-3 col-md-3 w-600 col-12">
                  <h5 class="title">{{ $t("footer.fllow") }}</h5>
                </div>
                <div class="col-5 col-lg-4 col-md-4 mb-4">
                  <div class="text-center qr-code">
                    <img
                      :src="require('@/assets/images/home/qr_gzh.png')"
                      alt=""
                    />
                    <span>{{ $t("footer.wechat_account") }}</span>
                  </div>
                </div>
                <div class="col-5 col-lg-4 col-md-4">
                  <div class="text-center qr-code">
                    <img
                      :src="require('@/assets/images/home/qr_sph.png')"
                      alt=""
                    />
                    <span>{{ $t("footer.wechat_channel") }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6 col-12">
              <div class="rn-footer-widget">
                <h4 class="title">{{ $t("footer.about_vyung") }}</h4>
                <div class="inner">
                  <ul class="footer-link link-hover">
                    <li>
                      <router-link
                        :to="{
                          name: 'about_us',
                          params: { lang: $i18n.locale },
                        }"
                        >{{ $t("footer.company_info") }}</router-link
                      >
                    </li>
                    <!-- <li>
                      <router-link
                        :to="{
                          path: `/${$i18n.locale}/about_us#scale`,
                          params: { lang: $i18n.locale },
                        }"
                        >{{ $t("footer.offices") }}</router-link
                      >
                    </li> -->
                    <li>
                      <!-- <a href="javascript:;">{{$t('footer.news')}}</a> -->
                      <router-link
                        :to="{ name: 'news', params: { lang: $i18n.locale } }"
                        >{{ $t("footer.news") }}</router-link
                      >
                    </li>
                    <!-- <li>
                                            <router-link to="/service">加入我们</router-link>
                                        </li> -->
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6 col-12">
              <div class="rn-footer-widget">
                <div class="widget-menu-top">
                  <h4 class="title">{{ $t("footer.links") }}</h4>
                  <div class="inner">
                    <ul class="footer-link link-hover">
                      <li>
                        <a target="_blank" href="https://www.hand-china.com/">{{
                          $t("footer.hand")
                        }}</a>
                      </li>

                      <li>
                        <a target="_blank" href="https://www.hand-us.com/">{{
                          $t("footer.hand_us")
                        }}</a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href="https://www.hand-europe.com/"
                          >{{ $t("footer.hand_eu") }}</a
                        >
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href="https://www.hand-japan.co.jp/"
                          >{{ $t("footer.hand_jp") }}</a
                        >
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href="https://www.hand-global.com/"
                          >{{ $t("footer.hand_sg") }}</a
                        >
                      </li>
                      <!-- <li>
                                                <a target="_blank" href="https://www.huilianyi.com/">{{$t('footer.hellos')}}</a>
                                            </li>
                                            <li>
                                                <a target="_blank" href="https://www.going-link.com/">SRM</a>
                                            </li>
                                            <li>
                                                <a target="_blank" href="https://www.dingyi-china.cn/">{{$t('footer.dingyi')}}</a>
                                            </li> -->
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6 col-12">
              <div class="rn-footer-widget">
                <h4 class="title">{{ $t("footer.more") }}</h4>
                <div class="inner">
                  <ul class="footer-link link-hover">
                    <li>
                      <router-link
                        :to="{ name: 'cases', params: { lang: $i18n.locale } }"
                        >{{ $t("footer.cases") }}</router-link
                      >
                    </li>
                    <!-- <li>
                                            <router-link to="/tab">开放平台</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/service">全场景效能平台</router-link>
                                        </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <Newsletter v-if="data.showNewsletter"/> -->
    </footer>
    <!-- End Footer Area  -->

    <Copyright v-if="data.showCopyright" />

    <ScrollTop />
  </div>
</template>

<script>
import Copyright from "./Copyright";
import Button from "../../elements/button/Button";
import Icon from "../../icon/Icon";
import ScrollTop from "./ScrollTop";
import Logo from "../../elements/logo/Logo";
import Newsletter from "./Newsletter";
import FeedBack from "./FeedBack";

export default {
  name: "Footer",
  components: {
    Newsletter,
    Logo,
    ScrollTop,
    Icon,
    Button,
    Copyright,
    FeedBack,
  },
  props: {
    data: {
      default: null,
    },
  },
};
</script>